export const getWidgetsList = (templates, widgets) => {
    let element = []
    widgets && (
        widgets.map((component, index) => {
            if (templates[component.name]) {
                const TargetComponent = templates[component.name]
                const data = component
                element.push(< TargetComponent {...data} key={index} />)
            }
        })
    )
    return element
}